import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { TransformCTA } from '../TransformCTA';
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-239" data-mp="3mh2cbymv9mhp">
      <div className="mx-auto max-w-3xl" data-id="element-240" data-mp="3mfhhe7wn41jb">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-brandred" data-id="element-241" data-mp="3r80tt1jlcqmj">
          🧠 Testimonios reales
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] leading-tight font-black tracking-tight text-navy sm:text-4xl" data-id="element-242" data-mp="o9werbpz2x">
          Lo que dicen los profesionales de salud
        </h2>

        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-243" data-mp="9378unrznrjw">
          <span className="flex" aria-hidden data-id="element-244" data-mp="e18v1hkpo6zl">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-245" data-mp="2au2cu2wcmx1p" data-mpi={i} />)}
          </span>
          <span className="text-[13px] font-bold text-navy/70" data-id="element-246" data-mp="2ft550mr8d8s9">4.9/5 · +1.200 profesionales</span>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-247" data-mp="1sm3wbv4kc6fn">
          {testimonials.map((t, i) => <figure key={t.name} className={['rounded-3xl border border-navy/10 bg-cream p-5', i === testimonials.length - 1 && testimonials.length % 2 === 1 ? 'sm:col-span-2' : ''].join(' ')} data-id="element-248" data-mp="1ns9j9ajgqppj" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-249" data-mp="2bhas2yw7k2vc">
                <img src={t.photo} alt={`Foto de ${t.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brandred/25" data-id="element-250" data-mp="26ldg14rz9iod" />
                <div data-id="element-251" data-mp="1xj44cbkz3j9e">
                  <figcaption className="text-[14px] font-extrabold text-navy" data-id="element-252" data-mp="1xlq9k4ke5mog">{t.name}</figcaption>
                  <p className="text-[12px] font-medium text-navy/50" data-id="element-253" data-mp="r1h0g555ajk2">{t.role}</p>
                  <span className="mt-0.5 flex" aria-hidden data-id="element-254" data-mp="m2w107xpw3wo">
                    {Array.from({
                  length: 5
                }).map((_, s) => <StarIcon key={s} className="h-3 w-3 fill-amber-400 text-amber-400" data-id="element-255" data-mp="njtciln8o7gt" data-mpi={s} />)}
                  </span>
                </div>
              </div>
              <blockquote className="mt-3 text-[14.5px] leading-snug text-navy/75" data-id="element-256" data-mp="ekodle7rmc44">
                “{t.text}”
              </blockquote>
            </figure>)}
        </div>

        <TransformCTA text="Quiero decidir con la misma seguridad que ellos" data-id="element-257" data-mp="4tjxuca9mn88" />
      </div>
    </section>;
}